import { render, staticRenderFns } from "./burtDate.vue?vue&type=template&id=4127aedf&scoped=true"
import script from "./burtDate.vue?vue&type=script&lang=js"
export * from "./burtDate.vue?vue&type=script&lang=js"
import style0 from "./burtDate.vue?vue&type=style&index=0&id=4127aedf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4127aedf",
  null
  
)

export default component.exports